import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Alert } from 'antd';

import Button from '../UI/Button';
import Checkbox from '../UI/Checkbox';
import Input from '../UI/Input';

import LoginStyleWrapper from './login.style';

import logo from './logo.jpg';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirectToReferrer: props.isLoggedIn,
      noError: true,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.isLoggedIn !== nextProps.isLoggedIn &&
      nextProps.isLoggedIn === true
    ) {
      this.setState({ redirectToReferrer: true });
    }
  }

  handleLogin = (e) => {
    e.preventDefault();
    const { username, password } = this.state;
    if (username === 'demo' && password === 'demo') {
      localStorage.setItem('auth', true);
      this.props.history.push('/');
    } else {
      this.setState({
        ...this.state,
        noError: false,
      });
    }
    return false;
  };

  onLoginChange = (name, e) => {
    this.setState({
      ...this.state,
      [name]: e.target.value,
    });
  }

  render() {
    const from = { pathname: '/' };
    const { redirectToReferrer } = this.state;

    if (redirectToReferrer) {
      return <Redirect to={from} />;
    }

    return (
      <LoginStyleWrapper className="isoSignInPage">
        <div className="isoLoginContentWrapper">
          <div className="isoLoginContent">
            <div className="isoLogoWrapper">
              <img src={logo} alt="d'Arta" width="50%" height="50%" />
            </div>
            <div style={{textAlign: 'center', lineHeight: '80px'}}>
              <h2>d'Arta Klantenlogin</h2>
            </div>
            <div style={{marginBottom: '15px'}} hidden={this.state.noError}>
              <Alert
                style={{fontSize: '14px'}}
                message="Uw gebruikersnaam of wachtwoord is onjuist."
                type="error"
              />
            </div>
            <div className="isoSignInForm">
              <form onSubmit={this.handleLogin}>
                <div className="isoInputWrapper">
                  <Input onChange={(e) => this.onLoginChange('username', e)} size="large" placeholder="Gebruikersnaam" />
                </div>
                <div className="isoInputWrapper">
                  <Input onChange={(e) => this.onLoginChange('password', e)} size="large" type="password" placeholder="Wachtwoord" />
                </div>

                <div className="isoInputWrapper isoLeftRightComponent">
                  <Checkbox>
                    Aangemeld blijven
                  </Checkbox>
                  <Button type="primary" htmlType="submit">
                    Aanmelden
                  </Button>
                </div>
              </form>
              <div className="isoCenterComponent isoHelperWrapper">
                <Link to="#" className="isoForgotPass">
                  Wachtwoord vergeten
                </Link>
                <Link to="#">
                  Registreren
                </Link>
              </div>
            </div>
          </div>
        </div>
      </LoginStyleWrapper>
    );
  }
}

export default connect(
  state => ({
    isLoggedIn: localStorage.getItem('auth') || false,
  }),
)(App);



// WEBPACK FOOTER //
// ./src/components/Login/Login.js